export default __webpack_public_path__ + "static/media/LeumitLogo.f4b0959d.png";